export const GAME_MOVED = 'NEW_MOVES/GAME_MOVED';
export const SEE_GAME = 'NEW_MOVES/SEE_GAME';
export const SET_GAMES_WITH_NEW_MOVES = 'NEW_MOVES/SET_GAMES_WITH_NEW_MOVES';

/** Moves come in bursts (the computer's turn): wait this long for quiet before asking the server again. */
export const QUIET_MS = 800;
